import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '../Css/CarouselDetails.css';
import { Pagination, Navigation } from 'swiper/modules';

const getFullImageUrl = (path) => `${path}`;

function CarouselDetails({ images }) {

  return (
    <Swiper
      pagination={{ type: 'fraction' }}
      navigation={true}
      modules={[Pagination, Navigation]}
      className="mySwiperD"
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img src={getFullImageUrl(image)} alt={`Slide ${index + 1}`} className="carousel-image" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default CarouselDetails;
